"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayoutFromLayoutProps = getLayoutFromLayoutProps;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var CacheWrappedLayout_1 = require("../core/list/layouts/CacheWrappedLayout");
var FluidGridLayout_1 = require("../core/list/layouts/FluidGridLayout");
var OptimalWidthGridLayout_1 = require("../core/list/layouts/OptimalWidthGridLayout");
var ProfilingWrappedLayout_1 = require("../core/list/layouts/ProfilingWrappedLayout");
var fluidGridLayout = new ((0, ProfilingWrappedLayout_1.createProfiledLayoutType)((0, CacheWrappedLayout_1.createCachedLayoutType)((0, ProfilingWrappedLayout_1.createProfiledLayoutType)(FluidGridLayout_1.FluidGridLayout, "FluidGridLayout")), "Cached.FluidGridLayout"))();
var optimalWidthGridLayout = new ((0, ProfilingWrappedLayout_1.createProfiledLayoutType)((0, CacheWrappedLayout_1.createCachedLayoutType)((0, ProfilingWrappedLayout_1.createProfiledLayoutType)(OptimalWidthGridLayout_1.OptimalWidthGridLayout, "OptimalWidthGridLayout")), "Cached.OptimalWidthGridLayout"))();
function getLayoutFromLayoutProps(listLayoutProps) {
    var layoutInfo = {
        options: __assign({}, listLayoutProps),
        layout: null,
    };
    switch (listLayoutProps.type) {
        case "fluidGrid":
            layoutInfo.layout = fluidGridLayout;
            break;
        case "optimalWidthGrid":
            layoutInfo.layout = optimalWidthGridLayout;
            break;
        default:
            throw new Error("Provided layout data props do not specify a valid layout type.");
    }
    return layoutInfo;
}
//# sourceMappingURL=PerformerListLayoutProps.js.map